define('config/config.common', [

], function() {

    // Parse QueryString
    var _GET = [];
    var queryArr = window.location.search.substring(1).split('&');
    for (var i = 0, len = queryArr.length; i < len; i++) {
        position = queryArr[i].indexOf('=');
        _GET[queryArr[i].substr(0, position)] = decodeURI(queryArr[i].substr((position + 1), queryArr[i].length)).replace(/\+/," ");
    }

    var config = {
        "queryString": _GET,
        "language": _environement.locale,
        "territory": _environement.storeId,
        "locale": _environement.locale + '_' + _environement.storeId,
        "deviceEnv": null,
        "base_url": window.maz_rooturl || window.location.protocol + '//' + window.location.hostname + window.location.pathname,
        "jsonPath": "datas/{{locale}}.json",
        "mmmId": "diorparfums",
        "appId": window.appFbId || "827676090584316",
        "trackingAPI": "dataLayer",
        "ecommerce": "shop", // "none" || "retailer" || "shop"
        "currencySymbol": { // TODO récupérer toutes les currency
            "EUR": "€",
            "JPY": "¥",
            "USD": "$"
        }
    };

    return config;
});
